import React from 'react';
import { Box } from '@mui/material';
import useScreenSize from '../../../utils/useScreenSize';
interface OnboardingStepImageProps {
  stepImage: React.ReactNode;
}

const OnboardingStepImage: React.FC<OnboardingStepImageProps> = ({ stepImage }) => {
  const { isLgScreen } = useScreenSize();

  if (!isLgScreen) return null;

  return (
    <Box
      data-testid='onboarding-page-image'
      sx={{
        '& svg': {
          width: 'auto',
          height: '100vh',
          objectFit: 'cover',
        },
      }}
    >
      {stepImage}
    </Box>
  );
};

export default OnboardingStepImage;
